import {Component, Input} from '@angular/core';
import {EventCreationModel} from "../../_models/event-creation-model";
import {EventCreationVerdict} from "../../_models/event-creation-verdict";
import {EventKind} from "../../../../enums/event-kind";

@Component({
  selector: 'location-weekday-event-view',
  imports: [],
  templateUrl: './weekday-event-view.component.html',
  styleUrl: './weekday-event-view.component.scss'
})
export class WeekdayEventViewComponent {
  @Input() event!: EventCreationModel;

  /**
   * What `AddMany?dryRun=true` said about this occurrence (#664) — absent when the preview is shown without a
   * dry run behind it, in which case the row is just the name, exactly as before the feature.
   */
  @Input() verdict?: EventCreationVerdict;

  protected readonly EventKind = EventKind;

  /** True when the server resolved this occurrence to a virtual event (whether requested or coerced). */
  protected get virtual(): boolean {
    return this.verdict?.kind === EventKind.Virtual;
  }

  /**
   * True when a *Kassen-Event* was asked for and a virtual one came back — the case worth marking separately,
   * because it is the only one where the preview differs from what was typed into the form.
   */
  protected get coerced(): boolean {
    return this.verdict?.coerced === true;
  }
}
